import axios from "axios";
import { toast } from "react-toastify";

export let URL = "https://app.dukanbuddy.com:5000/api/v1";
// export let URL = "http://localhost:5000/api/v1";
export let WHATSAPP_URL = "https://api.cogitofs.com/api/v1";
export let URL_PROFILE = "https://app.dukanbuddy.com:5000/uploads/avatar/";
export let CHAT_URL = "https://app.dukanbuddy.com:5000";
export const USER_ROLE = localStorage.getItem("role") || "";
// export const AWS_URL= 'https://dukaan-buddy.s3.ap-south-1.amazonaws.com/';
// export const AWS_URL = "https://my-dukan-bucket.s3.us-east-1.amazonaws.com/";
// export const AWS_URL = "https://s3.us-east-1.amazonaws.com/app.dukanbuddy.com/";
export const AWS_URL = "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/";

// Function to set dynamic headers
const configureAxios = () => {
  const AUTH_TOKEN = localStorage.getItem("token") || "";
  const LANG = localStorage.getItem("lng") || "en";
  const USER_ROLE = localStorage.getItem("role") || "";
  const NOTIFICATION_TOKEN = localStorage.getItem("f_token") || "";
  // const bussinessId = localStorage.getItem("bussinessId") || "";
  axios.defaults.baseURL = process.env.URL;
  axios.defaults.headers.common["x-auth-token"] = AUTH_TOKEN;
  axios.defaults.headers.common["notification-token"] = NOTIFICATION_TOKEN;
  axios.defaults.headers.common["role"] = USER_ROLE;
  // axios.defaults.headers.commmon["bussinessId"] = bussinessId;
  axios.defaults.headers["language"] = LANG;
  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
};

// Add response interceptor to handle permission errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const serverMessage = error.response?.data?.message;

    // Handle permission denied errors (403, 401)
    if (status === 403) {
      const permissionMessage =
        serverMessage || "You do not have permission to perform this action.";
      toast.error(permissionMessage);
      error.isPermissionError = true;
      error.permissionMessage = permissionMessage;
    } else if (status === 401) {
      const authMessage = serverMessage || "Access Denied. Please login again.";
      toast.error(authMessage);
      error.isAuthError = true;
      error.authMessage = authMessage;
    }

    // Attach server message to error for component-level handling
    if (serverMessage) {
      error.serverMessage = serverMessage;
    }

    return Promise.reject(error);
  },
);

// Axios instance with dynamic injection
export const http = {
  configureAxios,
  get: async (url, config) => {
    configureAxios();
    return axios.get(url, config);
  },
  post: async (url, data, config) => {
    configureAxios();
    return axios.post(url, data, config);
  },
  put: async (url, data, config) => {
    configureAxios();
    return axios.put(url, data, config);
  },
  patch: async (url, data, config) => {
    configureAxios();
    return axios.patch(url, data, config);
  },
  delete: async (url, config) => {
    configureAxios();
    return axios.delete(url, config);
  },
};